"use strict";

var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');


var RatingsView = Backbone.View.extend({

	events: {
		'click .ratings-next': 'nextItem',
		'click .ratings-prev': 'prevItem',
	},

	initialize: function() {
		this.listenTo(this.model, "change:items change:startIndex", this.render);
	},

	render: function() {
		var startIndex = this.model.get("startIndex");
		var itemsCount = this.model.get("items").length;
		var perPage = this.model.get("perPage");
		var items = this.model.get('items').slice(startIndex, startIndex + this.model.get('perPage'));

		var nextPageIndex = startIndex + perPage;
		var paginationInfo = [
		  	(startIndex + 1),
		];
		if ( perPage > 1 ) {
		  	paginationInfo.push("-");
		  	paginationInfo.push((nextPageIndex < itemsCount ? nextPageIndex : itemsCount));
		};
		if ( nextPageIndex <= itemsCount ) {
			paginationInfo.push(__("collectible.of"));
			paginationInfo.push(this.model.get("total"));
		}

		this.el.innerHTML = TemplateCache.render('ratings-template', {
			client: this.model.get("client"),
			items: items,
			startIndex: startIndex,
			itemsCount: itemsCount,
			perPage: perPage,
			hasPrev: startIndex > 0,
			hasNext: (startIndex + perPage) < itemsCount,
			paginationInfo: paginationInfo.join(" "),
		});
	},

	nextItem: function(e) {
		e.preventDefault();
		if ( this.startIndex >= this.model.length - 1  ) {
			return;
		}
		this.model.set("startIndex", this.model.get("startIndex") + 1);

		// Müssen wir mehr laden?
		if ( this.model.get("startIndex") > this.model.get("items").length - 2 ) {
			this.model.loadMore();
		}
	},

	prevItem: function(e) {
		e.preventDefault();
		if ( this.model.get("startIndex") === 0 ) {
			return;
		}
		this.model.set("startIndex", this.model.get("startIndex") - 1);
	},

});

module.exports = RatingsView;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/miniengine/views/RatingsView.js